import styled from 'styled-components';

export const MobileNumberWrapper = styled.div`
 width:100%;
 padding: 0 ${({ theme }) => theme.spacings[2].rem};

.PhoneInput {
	display: flex;
	align-items: center;
	width: 100%;
}

.PhoneInputInput {
	flex: 1;
	min-width: 0;
	font-family: Roboto;
    font-weight: normal;
    line-height: 1.25rem;
    font-size: 0.875rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    border: none;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.primary.graysGray};
    outline: none !important;
    padding: ${({ theme }) => theme.spacings[3].rem} ${({ theme }) =>
  theme.spacings[2].rem};
    width: 100%;
    height: 48px;
}

.PhoneInputCountryIcon {
	width: 28px;
	height: auto;
	margin-top:${({ theme }) => theme.spacings[1].rem};
}

.PhoneInputCountryIconImg {
	width: 100%;
	height: 100%;
}

/* Styling native country '<select/>'. */

.PhoneInputCountry {
	position: relative;
	align-self: stretch;
	display: flex;
	align-items: center;
	margin-right: 0.35em;
	justify-content: space-between;
	width:50px;
}

.PhoneInputCountrySelect {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 1;
	border: 0;
	opacity: 0;
	cursor: pointer;
}

.PhoneInputCountrySelect[disabled],
.PhoneInputCountrySelect[readonly] {
	cursor: default;
}

.PhoneInputCountrySelectArrow {
  border: solid ${({ theme }) => theme.colors.primary.graysGray};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

}`;
